'use strict';

const formValidation = require('../components/formValidation');
const createErrorNotification = require('../components/errorNotification');
const SELECTORS = {
    body: 'body',
    loginForm: '.js-login-form',
    registrationForm: '.js-registration-form',
    resetPasswordForm: '.js-reset-password-form',
    generalFormError: '.js-general-form-error',
    emailField: '.js-reg-email',
    emailConfirmField: '.js-reg-email-confirm',
    passwordField: '.js-reg-password',
    passwordConfirmField: '.js-reg-password-confirm',
    submitEmailBtn: '.js-submit-email-btn',
    closeEmailBtn: '.js-close-email-btn'
}

function login () {
    $(SELECTORS.loginForm).on('submit', function (e) {
        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');
        $(SELECTORS.loginForm).spinner().start();
        $('form.login').trigger('login:submit', e);

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $(SELECTORS.loginForm).spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                    $('form.login').trigger('login:error', data);
                } else {
                    $('form.login').trigger('login:success', data);

                    if (data.error && data.error.length > 0) {
                        form.find(SELECTORS.generalFormError).text(data.error[0]);
                        return;
                    }

                    location.href = data.redirectUrl;
                }
            },
            error: function (data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    $(SELECTORS.loginForm).spinner().stop();
                }
            }
        });
        return false;
    });
}

function register() {
    $(SELECTORS.registrationForm).on('blur', SELECTORS.emailField, function() {
        $(SELECTORS.emailConfirmField).val($(this).val());
    });

    $(SELECTORS.registrationForm).on('blur', SELECTORS.passwordField, function() {
        $(SELECTORS.passwordConfirmField).val($(this).val());
    });

    $(SELECTORS.registrationForm).on('submit', function (e) {
        e.preventDefault();

        $(SELECTORS.emailField).trigger('blur');
        $(SELECTORS.passwordField).trigger('blur');

        var form = $(this);
        var url = form.attr('action');
        $(SELECTORS.registrationForm).spinner().start();
        $('form.registration').trigger('login:register', e);

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $(SELECTORS.registrationForm).spinner().stop();
                if (!data.success) {
                    $('form.registration').trigger('login:register:error', data);
                    formValidation(form, data);
                } else {
                    $('form.registration').trigger('login:register:success', data);

                    if (data.error && data.error.length > 0) {
                        form.find(SELECTORS.generalFormError).text(data.error[0]);
                        return;
                    }

                    if (data.fields && Object.keys(data.fields).length) {
                        formValidation(form, data);
                        return;
                    }

                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                }

                $(SELECTORS.registrationForm).spinner().stop();
            }
        });
        return false;
    });
}

function resetPassword () {
    $(SELECTORS.resetPasswordForm).on('submit', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();

        $(SELECTORS.resetPasswordForm).trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();

                if (!data.success) {
                    formValidation(form, data);
                } else {
                    $('.request-password-title').text(data.receivedMsgHeading);
                    $('.request-password-body').empty()
                        .append('<p>' + data.receivedMsgBody + '</p>');
                    if (!data.mobile) {
                        $(SELECTORS.submitEmailBtn).addClass('d-none');
                        $(SELECTORS.closeEmailBtn).removeClass('d-none');
                    } else {
                        $('.send-email-btn').empty()
                        .html('<a href="'
                            + data.returnUrl
                            + '" class="f-button f-button--full-width f-button--green"> Close </a>'
                        ).attr('data-dismiss', 'modal');
                    }
                }
            },
            error: function () {
                form.spinner().stop();
            }
        });
        return false;
    });
}

module.exports = {
    login: login,
    register: register,
    resetPassword: resetPassword,
    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },
    loadEventRegData: function () {
        var params = $('.event-reg-params').data('params');
        if (params && typeof params === 'object') {
            $('#registration-form-fname').val(decodeURIComponent(params.primaryContactFirst));
            $('#registration-form-lname').val(decodeURIComponent(params.primaryContactLast));
            $('#registration-form-phone').val(decodeURIComponent(params.primaryContactPhone));
            $('#registration-form-email').val(decodeURIComponent(params.primaryContactEmail));
            $('#registration-form-email-confirm').val(decodeURIComponent(params.primaryContactEmail));
        }
    }
};
